import { PassStatus } from '../domain/passes';
import s from './ui.module.css';

const LABELS: Record<number, [string, string]> = {
  [PassStatus.Pending]: ['Оформляется', s.chipWaiting],
  [PassStatus.WaitingGuest]: ['Ждём данные', s.chipWaiting],
  [PassStatus.InviteCanceled]: ['Приглашение отменено', s.chipMuted],
  [PassStatus.Expected]: ['Ожидается', s.chipExpected],
  [PassStatus.Inside]: ['На территории', s.chipInside],
  [PassStatus.Expired]: ['Истёк', s.chipMuted],
  [PassStatus.Closed]: ['Закрыт', s.chipMuted],
};

export function StatusChip({ status }: { status: number }) {
  const [label, cls] = LABELS[status] ?? ['—', s.chipMuted];
  return <span className={`${s.chip} ${cls}`}>{label}</span>;
}
